import {request} from "./request";

export function SelectCourse(cid) {
  return request({
    url: 'student/SelectCourse',
    params: {
      cid
    }
  })
}

